// extracted by mini-css-extract-plugin
module.exports = {"Cover":"style_Cover__3LDSK","content":"style_content__1A4Yf"};